import { workArrangmentDescription } from 'src/app/utils/workArrangement/mapper';
import type { Tealium } from 'src/types/appState';

export default (tealium: Tealium) => {
  const { cajaWorkplaceOption } = tealium;
  return {
    workplaceOption: workArrangmentDescription(cajaWorkplaceOption),
  };
};
